import React from 'react';
const tomes = [{
  emoji: '💀',
  title: 'Tomo 1 — El Despertar',
  desc: 'Por qué fallaste mil veces. La biología detrás del scroll infinito.'
}, {
  emoji: '🧬',
  title: 'Tomo 2 — Bio-Hack Dopamínico',
  desc: 'Reset de dopamina en 7 días. Recuperá el placer de trabajar.'
}, {
  emoji: '🏗️',
  title: 'Tomo 3 — Ingeniería de Entorno',
  desc: 'Que distraerte sea difícil y enfocarte sea automático.'
}, {
  emoji: '⏰',
  title: 'Tomo 4 — Sistema de 3 Bloques',
  desc: 'Lográ en 90 minutos lo que antes te llevaba una semana.'
}, {
  emoji: '🚨',
  title: 'Tomo 5 — Protocolo S.O.S.',
  desc: 'El plan de rescate para los días que todo falla.'
}, {
  emoji: '🏆',
  title: 'Tomo 6 — Identidad Ejecutora',
  desc: 'Convertite en el que siempre TERMINA lo que empieza.'
}];
const includes = ['Protocolo de reset dopamínico paso a paso', 'Checklist diario, semanal y mensual de ejecución', 'Scripts de arranque para entrar en foco en 3 minutos', 'Sistema de bloqueo digital para iPhone y Android', 'Protocolo nocturno de apagado mental (7 minutos)', 'Tablero de control de progreso a 90 días', 'Plan anti-recaída para cuando todo falla', '100% adaptado a la realidad del emprendedor argentino'];
export function WhatYouGet() {
  return <section className="w-full px-4 py-10 text-base leading-6" style={{
    backgroundColor: '#0d0d0d',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-307">
      <div className="mx-auto max-w-4xl" data-id="element-308">

        {/* Heading */}
        <div className="text-center mb-8" data-id="element-309">
          <span className="text-xs font-bold tracking-widest text-yellow-400 uppercase mb-2 block" data-id="element-310">
            Sistema Completo
          </span>
          <h2 className="text-3xl sm:text-4xl font-black text-white m-0 leading-tight" data-id="element-311">
            Todo lo que{' '}
            <span className="text-yellow-400" data-id="element-312">recibís hoy</span>
          </h2>
          <p className="text-gray-400 text-sm mt-2 max-w-xl mx-auto" data-id="element-313">
            6 Tomos diseñados para llevarte de la distracción total a la ejecución profesional. Paso a paso.
          </p>
        </div>

        {/* 6 Tomos Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8" data-id="element-314">
          {tomes.map(tome => <div key={tome.title} className="flex items-start gap-3 bg-white/5 border border-yellow-400/20 rounded-xl p-4" data-id="element-315">
              <span className="text-2xl shrink-0" data-id="element-316">{tome.emoji}</span>
              <div data-id="element-317">
                <p className="text-sm font-black text-white m-0 mb-1" data-id="element-318">
                  {tome.title}
                </p>
                <p className="text-xs text-gray-400 m-0 leading-5" data-id="element-319">
                  {tome.desc}
                </p>
              </div>
            </div>)}
        </div>

        {/* Divider */}
        <div className="flex items-center gap-3 mb-6" data-id="element-320">
          <div className="flex-1 h-px bg-yellow-400/20" data-id="element-321" />
          <span className="text-xs font-bold text-yellow-400 uppercase tracking-widest" data-id="element-322">
            Cada tomo incluye
          </span>
          <div className="flex-1 h-px bg-yellow-400/20" data-id="element-323" />
        </div>

        {/* Includes Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 bg-yellow-400/5 border border-yellow-400/20 rounded-xl p-5" data-id="element-324">
          {includes.map(item => <div key={item} className="flex items-start gap-2" data-id="element-325">
              <span className="shrink-0 text-yellow-400 font-bold text-sm mt-0.5" data-id="element-326">
                ✅
              </span>
              <span className="text-xs text-gray-300 leading-5" data-id="element-327">{item}</span>
            </div>)}
        </div>

        {/* Bottom CTA hint */}
        <p className="text-center text-xs text-gray-500 mt-6" data-id="element-328">
          Todo en formato PDF • Acceso inmediato • 100% digital
        </p>

      </div>
    </section>;
}